import classNames from '@sindresorhus/class-names';
import Image from 'next/image';
import Link from 'next/link';

import chevron from '@web-landing/assets/images/chevron_white.svg';

import ProxyImage from '@web-landing/components/ProxyImage/ProxyImage';
import styles from '@web-landing/page_components/landing_page/components/TVBlock/TVBlock.module.scss';

import {miniPicksTestIds} from '@web-landing/constants/test-ids/mainLandingTestIds';

import {TVBlock as TVBlockType} from '@web-landing/strapi/types';

export const TVBlockSwiperLazy = ({tvApps}: Pick<TVBlockType, 'tvApps'>) => {
  return (
    <div className={styles.swiper}>
      <Image
        src={chevron.src}
        alt="back"
        className={classNames(styles.arrow, styles.arrow__left, {
          [styles.arrow__disabled]: true,
        })}
        width={48}
        height={48}
        data-testid={miniPicksTestIds.miniPicksBackButton}
      />

      {tvApps.map((app) => (
        <div
          key={app.href}
          className={classNames(styles.link, {
            [styles.disableLink]: !app.href,
          })}
        >
          <Link
            href={app.href ?? ''}
            target={app.isTargetBlank ? '_blank' : '_self'}
          >
            <ProxyImage
              imageData={app.backgroundImage}
              className={styles.linkImage}
            />
          </Link>
        </div>
      ))}
      <Image
        src={chevron.src}
        alt="further"
        className={styles.arrow}
        width={48}
        height={48}
      />
    </div>
  );
};
